import { toObject, getBrightness, darken } from "./utils";
import { scaleThreshold } from "d3-scale";
// import { readable, writable, derived } from "svelte/store";

// ///////////////////////////////////////////////////////////
// DATA
// ///////////////////////////////////////////////////////////

export const categories = [
	{
		id: "grundschulen",
		label: "Grund&shy;schulen",
		labelSingular: "Grundschule",
	},
	{
		id: "iss",
		label: "inte&shy;grierte Sek&shy;un&shy;dar&shy;schulen",
		labelSingular: "integrierte Sekundarschule",
		labelShort: "integ. Sekundarschulen",
	},
	{
		id: "gymnasien",
		label: "Gym&shy;nas&shy;ien",
		labelSingular: "Gymnasium",
	},
	{
		id: "gemeinschaftsschulen",
		label: "Gemeinschaftsschulen",
		labelSingular: "Gemeinschaftsschule",
	},
];
export const categoriesById = toObject(categories, "id");

export const bins = [
	{
		id: "mangel_0.8",
		label: "Starker Mangel", // Strong deficiency
		color: "#963E00",
		textColor: "#fff",
		upperLimit: 0.8,
	},
	{
		id: "mangel_0.85",
		label: "Erheblicher Mangel", // Significant deficiency
		color: "#CC661F",
		textColor: "#fff",
		upperLimit: 0.85,
	},
	{
		id: "mangel_0.9",
		label: "Mittlerer Mangel", // Moderate deficiency
		color: "#FF7816",
		textColor: "#fff",
		upperLimit: 0.9,
	},
	{
		id: "mangel_0.95",
		label: "Leichter Mangel", // Slight deficiency
		color: "#FFA451",
		textColor: "#fff",
		upperLimit: 0.95,
	},
	{
		id: "ok_0.995",
		label: "Leicht unterversorgt", // Sufficient
		color: "#FFCC81",
		textColor: "#fff",
		upperLimit: 0.995,
	},
	{
		id: "gut_versorgt_1",
		label: "Gut versorgt", // Well-supplied
		color: "#4BD5DE",
		textColor: "#fff",
		upperLimit: 1.05,
	},
	{
		id: "ueberversorgt",
		label: "Überversorgt", // Over-supplied
		color: "#0397A0",
		textColor: "#fff",
		upperLimit: Infinity,
	},
	{
		id: "no_data",
		label: "Keine Daten", // No data
		color: "#D9D9D9",
		textColor: "#fff",
	},
];

const ensureReadableWithWhiteText = (color) => {
	// Calculate the perceived brightness of the color.
	let brightness = getBrightness(color);

	if (brightness > 200) {
		const hex = color.startsWith("#") ? color : rgbStringToHex(color);
		let darkenedColor = darken(hex, 0.1); // you can adjust the amount to darken as needed
		return darkenedColor.toString();
	} else {
		return color;
	}
};

bins.forEach((bin) => {
	bin.chartPath = `${PATH}assets/images/charts/${bin.id}.svg`;
	bin.backgroundColor = ensureReadableWithWhiteText(bin.color);
});
console.log("bins", bins);

export const binsById = toObject(bins, "id");

const colors = bins.filter((b) => b.id != "no_data").map((b) => b.color);
const domain = bins.filter((b) => b.id != "no_data").map((b) => b.upperLimit);
export const colorScale = scaleThreshold().domain(domain).range(colors);
// color = value !== undefined ? colorScale(value) : binsById["no_data"].color;

export const getBin = (value) => {
	const bin = bins.find((bin) => value <= bin.upperLimit);
	return bin ? bin : binsById["no_data"];
};

// ///////////////////////////////////////////////////////////
// MAP
// ///////////////////////////////////////////////////////////

export const initialBounds = [
	[13.060173582792089, 52.335940554199595],
	[13.871243751485622, 52.6773085377948],
];

export const initialBoundsTablet = [
	[13.211867193817284, 52.27179558551268],
	[13.899423327757603, 52.735101645391296],
];

export const maxBounds = [
	[12.758595905118852, 52.227746928806766],
	[14.076183281386392, 52.782315046335015],
];

export const initialSelectedPoint = { lng: 13.389473278400644, lat: 52.51709032125603 };

export const baseOpacity = 0.75;
export const baseOpacityLuftbilder = 0.5;

export const bezirke = {
	"01": "Mitte",
	"02": "Friedrichshain-Kreuzberg",
	"03": "Pankow",
	"04": "Charlottenburg-Wilmersdorf",
	"05": "Spandau",
	"06": "Steglitz-Zehlendorf",
	"07": "Tempelhof-Schöneberg",
	"08": "Neukölln",
	"09": "Treptow-Köpenick",
	10: "Marzahn-Hellersdorf",
	11: "Lichtenberg",
	12: "Reinickendorf",
};

export const markerData = [{ n: "fernsehturm", lat: 52.52084869043665, lon: 13.409393064444167 }];
